import React from 'react';
export function IntroSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10 mb-10" data-id="element-3743">
      <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-3744">
        WE WANT TO BUY YOUR USED EDM MACHINE!
      </h2>
      <p className="text-gray-700 text-lg leading-relaxed mb-4" data-id="element-3745">
        In addition to being Michigan's exclusive GF Machining Solutions dealer,
        we are also the <strong data-id="element-3746">#1 USED EDM dealer</strong> for all makes and
        models throughout North America (and beyond!)
      </p>
      <p className="text-gray-700 text-lg leading-relaxed mb-8" data-id="element-3747">
        We are interested in purchasing all well maintained EDM machines in good
        working order dating back to 2005 (2000 for Agie/Charmilles)
        <strong data-id="element-3748">**</strong>
      </p>

      <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-3749">
        Looking to buy a USED EDM Machine?
      </h2>
      <p className="text-gray-700 text-lg leading-relaxed mb-4" data-id="element-3750">
        Check out our current inventory!
      </p>
      <a href="59m7/used-equipment/used-edm-machines.html" target="_blank" rel="noopener noreferrer" className="inline-block text-orange font-bold text-lg hover:underline mb-6" data-id="element-3751">
        Used EDM Machine Inventory →
      </a>

      <p className="text-gray-700 text-lg leading-relaxed" data-id="element-3752">
        Please fill out the contact form below and a representative will reach
        out to you as soon as possible.
      </p>
    </div>;
}